import { render, staticRenderFns } from "./educationBrands.vue?vue&type=template&id=455185fe&scoped=true"
import script from "./educationBrands.vue?vue&type=script&lang=js"
export * from "./educationBrands.vue?vue&type=script&lang=js"
import style0 from "./educationBrands.vue?vue&type=style&index=0&id=455185fe&prod&lang=scss&scoped=true"
import style1 from "./educationBrands.vue?vue&type=style&index=1&id=455185fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455185fe",
  null
  
)

export default component.exports